import { React, useState, useEffect } from 'react';
import JSONTableEditor from '../../JSONTableEditor';
import DynamicForm from '../../DynamicForm';
import CentralCalls from '../../../centralCalls';
//import { useNavigate } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, IconButton, Tooltip, MenuItem, Select, TextField } from '@mui/material';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LotFilter from '../../workInProgress/LotFilter';
import PostFinishJobAutomation from '../PostFinishJobAutomation';
import FinishTaskDialog from '../FinishTaskDialog';
import { Auth } from 'aws-amplify';
const ActivePhase = ({
    phaseType,
    handleWipLinkClick,
    handleOpenPhaseFilesClick,
    checkDisplayPhaseFiles,
    filterType,
    startDate,
    endDate,
    isInspection,
    refreshMenu,
    isQc
}) => {
    const [refresh, setRefresh] = useState(false);
    const [PhaseOid, setPhaseOid] = useState(null);
    //const [setRefreshMenuKey, refreshMenuKey] = useState(false);
    //const [phaseName, setPhaseName] = useState('');
    //const [addQCDialogOpen, setAddQCDialogOpen] = useState(false);
    //const [qcTitle, setQcTitle] = useState('UNSET');
    const [StatusDialogOpen, setStatusDialogOpen] = useState(false);
    const [LotOid, setLotOid] = useState(null);
    const [UndergroundDialogOpen, setUndergroundDialogOpen] = useState(false);
    const [lotTitle, setLotTitle] = useState('not title');
    const [PunchDialogOpen, setPunchDialogOpen] = useState(false);
    const [punchLotOid, setPunchLotOid] = useState(null);
    const [qcPhaseOptions, setQcPhaseOptions] = useState([]);
    const [selectedPhaseForQC, setSelectedPhaseForQC] = useState(0);
    const [selectedSecondaryPhaseForQC, setSelectedSecondaryPhaseForQC] = useState('slab_inspection');
    const [secondaryInspectionLotOid, setSecondaryInspectionLotOid] = useState(0);
    const [NewQCLotOid, setNewQCLotOid] = useState(0);
    const [AddQCValid, setAddQCValid] = useState(null);
    const [refreshUndergroundKey, setRefreshUndergroundKey] = useState(0);
    // PostFinishJobAutomation state
    const [postFinishAutomationOpen, setPostFinishAutomationOpen] = useState(false);
    const [postFinishRow, setPostFinishRow] = useState(null);
    const [isUploadingFinishTaskFiles, setIsUploadingFinishTaskFiles] = useState(false);
    const [finishTaskUploadUserName, setFinishTaskUploadUserName] = useState('unknown');
    const access_level = localStorage.getItem('access');
 
    useEffect(() => {
        const getLotTitle = async () => {
            const title = await CentralCalls.callStoredProcedureWithParams('sp_getLotTitle', { lot_oid: LotOid });
            setLotTitle(title.title);
        }
        getLotTitle();
    }, [LotOid]);

    useEffect(() => {
        const setUserInfo = async () => {
            try {
                const user = await Auth.currentAuthenticatedUser();
                setFinishTaskUploadUserName(user?.attributes?.email || user?.username || 'unknown');
            } catch (error) {
                console.error('Error fetching user info', error);
                setFinishTaskUploadUserName('unknown');
            }
        };

        setUserInfo();
    }, []);

    const uploadFinishTaskFiles = async (phaseRow, filesToUpload) => {
        if (!phaseRow?.phase_oid || !LotOid || !filesToUpload || filesToUpload.length === 0) {
            return;
        }

        setIsUploadingFinishTaskFiles(true);
        try {
            for (const file of filesToUpload) {
                const formData = new FormData();
                formData.append('file', file);
                formData.append('lot_oid', LotOid);
                formData.append('uploaded_by', finishTaskUploadUserName || 'unknown');

                const response = await fetch('/api/files/upload', {
                    method: 'POST',
                    body: formData,
                });

                if (!response.ok) {
                    const errorData = await response.json().catch(() => ({}));
                    throw new Error(errorData.error || `Upload failed for ${file.name}`);
                }

                const uploadedRow = await response.json();
                if (uploadedRow?.oid) {
                    await CentralCalls.upsertData({ oid: uploadedRow.oid, phase_oid: phaseRow.phase_oid }, 'files', 'update');
                }
            }
        } finally {
            setIsUploadingFinishTaskFiles(false);
        }
    };

    const procedureDetails = {
        procedureName: 'ui_sp_getPhasePageData',
        parameters: { phase_type: phaseType, page_type: filterType, start_date: CentralCalls.sqlFormatdate(startDate), end_date: CentralCalls.sqlFormatdate(endDate) },  // If there are any parameters, define them here as an object
    };
    const handleSave = async (phaseRow) => {
        console.log('saved row..', phaseRow);
        if (Array.isArray(phaseRow.employee_oids) && phaseRow.employee_oids.length > 0) {
            var employee_team = await CentralCalls.callStoredProcedureWithParams('sp_getOrCreateCrew', {'employeeOids': phaseRow.employee_oids});
            CentralCalls.upsertData({'oid': phaseRow.oid, employee_team_oid: employee_team[0].employee_team_oid}, 'phase_status', 'update');
        }
        //console.log('data emplyes..',phaseRow.employee_oids,Array.isArray(phaseRow.employee_oids),phaseRow.employee_oids.length === 0  );
         if (Array.isArray(phaseRow.employee_oids) && phaseRow.employee_oids?.length === 0){
            console.log('no employees assigned, setting team to null');
            CentralCalls.upsertData({'oid': phaseRow.oid, employee_team_oid: null}, 'phase_status', 'update');
         }
        CentralCalls.upsertData({ 'oid': phaseRow.phase_oid, 'date_scheduled': phaseRow.date_scheduled, 'builder_date': phaseRow.builder_date, 'is_punch': phaseRow.is_punch ? 1 : 0 }, 'phase', 'update');
        console.log('done phase update');
    };
    const checkDisplayComplete = (phaseRow) => {
        if ((phaseRow.date_scheduled && phaseRow.date_scheduled !== null && phaseRow.employee_team_oid) || (phaseRow.is_inspection && phaseRow.date_scheduled && phaseRow.date_scheduled !== null)) { return true; } else { return false; }
    }
    const checkDisplayUndergroundApproval = (phaseRow) => {
        if (phaseType === 'underground') { return true; } else { return false; }
    }
    const checkDisplayNonComplete = (phaseRow) => {
        if (phaseRow.is_single_status === 0 && phaseRow.is_qc !== 1 && phaseRow.is_inspection !== 1) { return true; } else { return false; }
    }
    const checkDisplayOnHold = (phaseRow) => {
        return access_level === 'full' ? true : false;
    }
    const checkAllowCancel = (phaseRow) => {
        return access_level === 'full' ? true : false;
    }
    const handleCancelClick = async (phaseRow) => {
        const confirmCancellation = window.confirm("Are you sure you want to cancel job?");
        if (confirmCancellation) {
            await CentralCalls.upsertData({ 'oid': phaseRow.oid, 'status': 'cancel', 'status_date': new Date() }, 'phase_status', 'update');
            setRefresh(new Date().getTime());
            refreshMenu();
        }
    }
    const handleRevertNonCompleteRecentClick = async (phaseRow) => {
        await CentralCalls.callStoredProcedureWithParams('revert_phase_status', { 'phase_oid': phaseRow.phase_oid });
        setRefresh(new Date().getTime());
        refreshMenu();
    }
   
    const handleCompletePhase = async (phaseRow) => {
        setStatusDialogOpen(true);
        setLotOid(phaseRow.lot_oid);
        setPhaseOid(phaseRow.phase_oid);
        refreshMenu();
    };
    // const handleAddPunchClick = async () => {
    //     const newPhase = await CentralCalls.upsertData({ 'lot_oid': punchLotOid, 'phase_type': phaseType, 'is_punch': 1 }, 'phase', 'insert');
    //     await CentralCalls.upsertData({ 'phase_oid': newPhase.oid }, 'phase_status', 'insert');
    //     closePunchDialog();
    // }
    // const refreshLocal = () => {
    //     refreshMenu();
    // }
    const handleSaveUndergroundHistory = async (phaseRow) => { }
    const handleDisplayUndergroundApprovalClick = async (phaseRow) => {
        setRefresh(new Date().getTime());
        setPhaseOid(phaseRow.phase_oid);
        setLotOid(phaseRow.lot_oid);
        setUndergroundDialogOpen(true);
        refreshMenu();
    }
    // const handleCompletephaseClose = async (phaseRow) => {
    //     setStatusDialogOpen(false);
    //     setPhaseOid(phaseRow.phase_oid);
    //     if (phaseRow.phase_type === 'slab') {
    //         const updateObj = {
    //             oid: LotOid,
    //             sewer_location: phaseRow.sewer_location,
    //             water_location: phaseRow.water_location,
    //         };
    //         try {
    //             const response = await fetch('/api/update', {
    //                 method: 'POST',
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                 },
    //                 body: JSON.stringify({ tableName: 'lot', updateObj: updateObj }),
    //             });
    //             const data = await response.json();
    //         } catch (err) {
    //             console.error(err);
    //             // Handle error
    //         }
    //     }
    //     if (phaseRow.finished === 1 && (phaseRow.status === 'fail')) {
    //         const insertObj = {
    //             phase_oid: phaseRow.phase_oid,
    //             comments: phaseRow.comments,
    //             employee_oids: JSON.stringify(phaseRow.employee_oids)
    //         };
    //         await CentralCalls.upsertData(insertObj, 'phase_status', 'insert');
    //         setRefresh(new Date().getTime());
    //     }
    //     if (isQc === 1 || isInspection === 1) {
    //         CentralCalls.upsertData({ 'oid': phaseRow.phase_oid, 'qc_status': phaseRow.qc_status }, 'phase', 'update');
    //     }
    //     if ((isQc === 1 || isInspection === 1) && phaseRow.qc_status === 'fail') {
    //         failedQCAutoPunch(phaseRow);
    //     }
    // };
    const handleCompleteUndergroundClose = async (undergroundRow) => {
        setUndergroundDialogOpen(false);
    }
    // const handleSavePhaseSaveEdit = async (phaseRow) => {

    // }
    // const handleLotSelected = async (lot_oid) => {
    //     setPunchLotOid(lot_oid);
    // }
    // const handleSelectedPhaseForQCChange = async (event) => {
    //     const oid = event.target.value;
    //     if (oid !== 0) {
    //         setAddQCValid(true);
    //     }
    //     else {

    //     }
    //     setSelectedPhaseForQC(oid);
    // }
    // const failedQCAutoPunch = async (phaseRow) => {
    //     const punchPhaseType = phaseType.split('_')[0];
    //     const newPhase = await CentralCalls.upsertData({ 'lot_oid': LotOid, 'phase_type': punchPhaseType, 'is_punch': 1, 'punch_comments': phaseRow.comments, 'builder_date': phaseRow.date_scheduled }, 'phase', 'insert');
    //     await CentralCalls.upsertData({ 'phase_oid': newPhase.oid }, 'phase_status', 'insert');
    // }
    // const onFilterSelect = (filter_name_id) => {
    //     console.log(filter_name_id);
    // }
    // const setQCPhaseOptions = async (selected_lot_oid, secondary_phase_type) => {
    //     console.log('setting qc phase options...' + selected_lot_oid);
    //     const qcForPhaseType = phaseType.split('_')[0];
    //     var this_phase_type = qcForPhaseType;
    //     if (isInspection === 1) {
    //         console.log(secondary_phase_type.split('_')[0])
    //         this_phase_type = secondary_phase_type.split('_')[0];
    //     }
    //     //console.log({ lot_oid: parseInt(lot), phase_type: this_phase_type, is_inspection : isInspection, inspection_phase_type : selectedSecondaryPhaseForQC })
    //     const result = await CentralCalls.callStoredProcedureWithParams('sp_checkLotExistingQC', { lot_oid: parseInt(selected_lot_oid), phase_type: this_phase_type, is_inspection: isInspection, inspection_phase_type: selectedSecondaryPhaseForQC });
    //     if (!result || result.length === 0) {
    //         setQcPhaseOptions([], selectedSecondaryPhaseForQC);
    //         //CentralCalls.upsertData({ deleted: 0, oid: deletedRow.oid }, 'permit', 'update');
    //         //setAddQCValid(false);         
    //     } else {
    //         setNewQCLotOid(selected_lot_oid);
    //         //setAddQCValid(true);
    //         setQcPhaseOptions(result, selectedSecondaryPhaseForQC);
    //     }
    // }
    // const OpenQCDialogOpen = async () => {
    //     setAddQCDialogOpen(true);
    //     setQcPhaseOptions([]);
    //     setSelectedPhaseForQC(0);
    //     setAddQCValid(false);
    // }
    // const closePunchDialog = async () => {
    //     setPunchDialogOpen(false);
    //     setPunchLotOid(null);
    // }
    // const addPunch = async () => {
    //     setPunchDialogOpen(true);
    // }
    // const confirmLotQCAddOption = async (lot) => {
    //     setQCPhaseOptions(lot, selectedSecondaryPhaseForQC);
    //     setSecondaryInspectionLotOid(lot);
    // }
    // const insertNewQC = async () => {
    //     //const qcForPhaseType = phaseType.split('_')[0];
    //     var phase_type_now = phaseType;
    //     if (isInspection) {
    //         phase_type_now = selectedSecondaryPhaseForQC;
    //     }
    //     const phaseRow = await CentralCalls.upsertData({ lot_oid: NewQCLotOid, phase_type: phase_type_now, qc_phase_oid: selectedPhaseForQC }, 'phase', 'insert');
    //     await CentralCalls.upsertData({ 'phase_oid': phaseRow.oid }, 'phase_status', 'insert');
    //     //const nonQCPhase = await CentralCalls.fetchTableData('phase', { lot_oid: NewQCLotOid, phase_type: phaseType, });
    //     //await CentralCalls.upsertData({ oid: selectedPhaseForQC, qc_phase_oid : phaseRow.oid }, 'phase', 'update');
    //     setAddQCDialogOpen(false);
    //     //setRefreshKeyOpen(refreshKeyOpen +1);
    // }
    const handleSavePhaseSaveEdit = async (phaseRow) => { }
    const handlePutOnHold = async (phaseRow) => {
        const confirmCancellation = window.confirm("Are you sure you want to put this job on hold?");
        if (confirmCancellation) {
            await CentralCalls.upsertData({ 'oid': phaseRow.oid, 'status': 'hold', 'status_date': new Date() }, 'phase_status', 'update');
            setRefresh(new Date().getTime());
        }
    }
    const handleCompletephaseClose = async (phaseRow, selectedFiles = []) => {
        setStatusDialogOpen(false);
        console.log('handling phase close...', phaseRow);

        if (selectedFiles.length > 0) {
            try {
                await uploadFinishTaskFiles(phaseRow, selectedFiles);
            } catch (uploadErr) {
                console.error('Error uploading finish task files', uploadErr);
                alert(uploadErr?.message || 'Task completed, but one or more files failed to upload.');
            }
        }
        
        // Trigger the PostFinishJobAutomation component
        setPostFinishRow(phaseRow);
        setPostFinishAutomationOpen(true);
    };

    // Callback when PostFinishJobAutomation completes
    const handlePostFinishAutomationComplete = async () => {
        setPostFinishAutomationOpen(false);
        setPostFinishRow(null);
        setRefresh(new Date().getTime());
        refreshMenu();
    };
    const procedureDetailsUndergroundTickets = {
        procedureName: 'ui_getUndergroundTickets',
        parameters: { phase_oid: PhaseOid, lot_oid: LotOid }
    }
    // const procedureDetailsCompletion = {
    //     procedureName: 'ui_sp_getPhaseCompletionPageData',
    //     parameters: { phase_oid: PhaseOid, lot_oid: LotOid },  // If there are any parameters, define them here as an object
    // };
    // const procedureDetailsCompletionInsert = {
    //     procedureName: 'ui_sp_getPhaseCompletionPageDataInsert',
    //     parameters: { phase_oid: PhaseOid, phase_type: phaseType, lot_oid: LotOid },  // If there are any parameters, define them here as an object
    // };
    const procedureDetailsUndergroundHistory = {
        procedureName: 'ui_sp_wipUndergroundTickets',
        parameters: { lot_oid: LotOid },
    }
    const customFunctions = [
        {
            display_name: 'Complete',
            type: 'check', // type must correspond to a FontAwesome icon name
            func: handleCompletePhase,
            displayCheck: checkDisplayComplete
        },
        {
            display_name: 'Revert',
            type: 'revert', // type must correspond to a FontAwesome icon name
            func: handleRevertNonCompleteRecentClick,
            displayCheck: checkDisplayNonComplete
        },
        {
            display_name: 'Underground Ticket',
            type: 'approval', // type must correspond to a FontAwesome icon name
            func: handleDisplayUndergroundApprovalClick,
            displayCheck: checkDisplayUndergroundApproval
        },
        {
            display_name: 'Hold',
            type: 'pause', // type must correspond to a FontAwesome icon name
            func: handlePutOnHold,
            displayCheck: checkDisplayOnHold
        },
        {
            display_name: 'Cancel',
            type: 'cancel',
            func: handleCancelClick,
            displayCheck: checkAllowCancel
        },
        {
            display_name: 'WIP',
            type: 'overview',
            func: handleWipLinkClick
        },
        {
            display_name: 'Files',
            type: 'phaseFiles',
            func: handleOpenPhaseFilesClick
        }
    ]
    return (
        <>
            {/* <h2> {phaseName === 'Slab Inspection' ? 'Inspections' : phaseName}
                {isQc !== 1 && (
                    <Tooltip title="Add Punch">
                        <IconButton color="primary" aria-label="save" onClick={addPunch} size="medium">
                            <FontAwesomeIcon icon={faPlus} />
                        </IconButton>
                    </Tooltip>
                )}
                {isQc === 1 && (
                    <Tooltip title={qcTitle}>
                        <IconButton color="primary" aria-label="save" onClick={() => { OpenQCDialogOpen() }} size="medium">
                            <FontAwesomeIcon icon={faPlus} />
                        </IconButton>
                    </Tooltip>
                )}
            </h2> */}
            {/* <ActivePhaseButtonGroup onFilterSelect={onFilterSelect}  ></ActivePhaseButtonGroup> */}

            <JSONTableEditor
                procedureDetails={procedureDetails}
                onSave={handleSave}
                sortOrder={{
                    'enabled': 'desc',
                    'date_scheduled': 'asc',
                    'builder_date': 'asc',
                    'builder': 'asc',
                    'neighborhood': 'asc',
                    'lot_num': 'asc',
                    'phase_for_inspection': 'asc'
                }}
                customFunctions={customFunctions} />
            <Dialog fullWidth={true} maxWidth='lg' open={UndergroundDialogOpen} onClose={() => setUndergroundDialogOpen(false)}>
                <DialogContent >
                    <>
                        <h2>Tickets</h2>
                        <h4>{lotTitle}</h4>
                        <JSONTableEditor
                            key={refreshUndergroundKey + 1}
                            procedureDetails={procedureDetailsUndergroundHistory}
                            onSave={handleSaveUndergroundHistory}
                            allowDelete={true}
                            sortOrder={{
                                'oid': 'desc'
                            }} >
                        </JSONTableEditor>
                        <h2>New Ticket
                        </h2>
                        <DynamicForm
                            key={refreshUndergroundKey}
                            procedureDetails={procedureDetailsUndergroundTickets}
                            onSave={handleCompleteUndergroundClose}
                            saveName='Insert'
                            crudType='insert' ></DynamicForm>
                    </>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setUndergroundDialogOpen(false)} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <FinishTaskDialog
                open={StatusDialogOpen}
                onClose={() => setStatusDialogOpen(false)}
                title={lotTitle}
                phaseOid={PhaseOid}
                lotOid={LotOid}
                phaseType={phaseType}
                onCompletePhaseClose={handleCompletephaseClose}
                onSavePhaseSaveEdit={handleSavePhaseSaveEdit}
                isUploading={isUploadingFinishTaskFiles}
            />
            
            {/* PostFinishJobAutomation component */}
            {postFinishRow && (
                <PostFinishJobAutomation
                    row={postFinishRow}
                    lotOid={LotOid}
                    open={postFinishAutomationOpen}
                    onClose={() => setPostFinishAutomationOpen(false)}
                    onComplete={handlePostFinishAutomationComplete}
                />
            )}
        </>
    );
};

export default ActivePhase;
